import { AvatarImage, AvatarFallback, Status } from './styles';

export interface AvatarProps {
  size?: 'xs' | 'sm' | 'md' | 'lg';
  image?: string;
  alt?: string;
  withOutline?: boolean;
  isOnline?: boolean;
  rounded?: boolean;
}

export const Avatar = ({
  size = 'sm',
  image,
  withOutline,
  isOnline = false,
  rounded = false,
}: AvatarProps): JSX.Element => {
  const dataTestId = 'AVATAR_IMAGE';

  return image ? (
    <AvatarImage
      size={size}
      outlined={withOutline}
      src={image}
      rounded={rounded}
      data-testid={dataTestId}
    />
  ) : (
    <AvatarFallback size={size} outlined={withOutline} rounded={rounded} data-testid={dataTestId} />
  );
};

export default Avatar;
